<template>
  <div class="">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "default-layout"
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/layouts/Default.vue